export enum AuthMutationTypes {
  'SET_GENERATE_TOKEN' = 'SET_GENERATE_TOKEN',
  'SET_AUTH_USER' = 'SET_AUTH_USER',
  'SET_USER_VERIFICATION' = 'SET_USER_VERIFICATION',
  'SET_USER_INFO' = 'SET_USER_INFO',
  'SET_FIRST_LOGIN' = 'SET_FIRST_LOGIN',
  'SET_LANGUAGE_LOADED' = 'SET_LANGUAGE_LOADED',
  'RESET_USER' = 'RESET_USER',
  'SET_GIGYA_FALLBACK' = 'SET_GIGYA_FALLBACK',
}
